import { render, staticRenderFns } from "./dependent.vue?vue&type=template&id=83cb5534&"
import script from "./dependent.vue?vue&type=script&lang=js&"
export * from "./dependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports